// Feature list items for "What's included" section
export const FEATURE_ITEMS = [
  {
    id: 'risk-scores',
    icon: 'clock',
    title: 'Risk scores for 21 cancers',
    description: 'Built from over **500 validated risk-factors**',
    descriptionBold: '500 validated risk-factors',
  },
  {
    id: 'biomarkers',
    icon: 'pulse',
    title: 'Insights from 50+ biomarkers',
    description: 'See which markers matter and **how to improve them**',
    descriptionBold: 'how to improve them',
  },
  {
    id: 'prevention-plan',
    icon: 'checkbox',
    title: 'A personalized prevention plan',
    description: 'Simple, targeted steps proven to **lower your risk by 60%**',
    descriptionBold: 'lower your risk by 60%',
  },
  {
    id: 'screening',
    icon: 'document',
    title: 'Smarter screening guidance',
    description: 'Know **which tests to get** and when',
    descriptionBold: 'which tests to get',
  },
  {
    id: 'integrations',
    icon: 'chart',
    title: 'Apple Health, FitBit and Whoop integration',
    description: 'Track how daily habits **shift your risk**',
    descriptionBold: 'shift your risk',
  },
] as const;

// Testimonial data for social proof section
export const TESTIMONIALS = [
  {
    id: 'sarah',
    quote:
      '"Catch showed me I was at risk but it also gave me a clear plan. Seeing that 39% drop in my risk was the first time I felt like I was actually in control of my health."',
    name: 'Sarah M.',
    title: 'Member since 2023',
    avatarUrl: '/images/testimonials/sarah-cropped.png'
  },
  {
    id: 'dr-chen',
    quote:
      '"I recommend Catch to patients who want to be proactive. The reports are thorough, and they actually cite their sources."',
    name: 'Dr. James Chen',
    title: 'Oncologist',
    avatarUrl: '/images/testimonials/dr-chen-cropped.jpg'
  },
] as const;

// Privacy badges for "Your data stays yours" section
export const PRIVACY_BADGES = [
  {
    id: 'hipaa',
    icon: 'caduceus',
    label: 'HIPAA aligned',
  },
  {
    id: 'encryption',
    icon: 'lock',
    label: 'AES-256 Encryption',
  },
  {
    id: 'never-sold',
    icon: 'no-sale',
    label: 'Never Sold',
  },
] as const;

// Trial benefits shown below payment form
export const TRIAL_BENEFITS = [
  {
    id: 'no-charge',
    text: 'No charge for 7 days',
  },
  {
    id: 'cancel',
    text: 'Cancel anytime',
  },
  {
    id: 'guarantee',
    text: '14-day money-back guarantee',
  },
] as const;

// Trust badges shown at bottom of payment card
export const TRUST_BADGES = [
  {
    id: 'ssl',
    icon: 'ssl',
    label: 'SSL SECURE',
  },
  {
    id: 'hipaa',
    icon: 'caduceus',
    label: 'HIPAA ALIGNED',
  },
] as const;

// FAQ items (fallback if Webflow API fails)
export const DEFAULT_FAQS = [
  {
    id: 'trial',
    question: 'How does the 7-day free trial work?',
    answer:
      'Start your free trial today and get full access to all Catch features. You won\'t be charged until day 8. Cancel anytime before then and pay nothing.',
  },
  {
    id: 'cancel',
    question: 'Can I cancel anytime?',
    answer:
      'Yes! You can cancel your subscription at any time from your account settings. If you cancel during your trial, you won\'t be charged.',
  },
  {
    id: 'accuracy',
    question: 'How accurate is the risk assessment?',
    answer:
      'Our risk models are built from over 500 validated risk factors and peer-reviewed research. We continuously update our algorithms based on the latest scientific studies.',
  },
  {
    id: 'security',
    question: 'Is my health data secure?',
    answer:
      'Absolutely. We use AES-256 encryption, are HIPAA aligned, and never sell your data. You can delete your data at any time.',
  },
] as const;

// Member count for social proof
export const MEMBER_COUNT = '17,000+';
export const MEMBER_COUNT_BASE = 17942;
